import Axios from 'axios';
import { get } from 'lodash-es';
import Cookies from 'js-cookie';
import { message } from '@fuxi/eevee-ui';
import { sendEvent } from 'common/tracker';
import { CustomEvent } from 'common/tracker/custom-event';
import { UploadFileType } from 'common/constants';
import { FosAxiosInstance } from 'common/service/axiosInstances';
import { getEnv } from 'common/utils';

const CancelToken = Axios.CancelToken;
const fosHost = getEnv().fosHost;
const prefix = '/object-upload';

const upload = {
  getFileMd5(file_name) {
    return FosAxiosInstance.post(`${prefix}/api/upload_id`, { file_name })
      .then(({ data }) => {
        const fileMd5 = get(data, ['id']);
        return fileMd5 as string;
      })
      .catch(() => {});
  },
  uploadSingleFile(file, onSuccess, onError, showMessage = true) {
    const form = new FormData();
    form.append('file', file);
    return FosAxiosInstance.post(`${prefix}/api/sdk/upload`, form, {
      headers: {
        Cookies: `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}`,
      },
    })
      .then(({ data }) => {
        const downloadUrl = get(data, [file.name]);
        onSuccess?.(downloadUrl);
        showMessage && message.success(`${file.name}上传成功`);
        return downloadUrl as string;
      })
      .catch(() => {
        message.error(`${file.name}上传失败`);
        onError?.();
      });
  },

  uploadFileByProxy(
    file: File,
    uploadType: string,
    showMessage = true,
    trackerObj?: any,
    onSuccess?: (url: string, uniqueId: string) => void,
    onError?: () => void,
    onProgress?: (percent: number) => void,
  ): Promise<string | null> {
    const form = new FormData();

    form.append('file', file);

    form.append('timestamp', new Date().getTime().toString());
    form.append('file_type', uploadType);

    const startTime = Date.now();

    return FosAxiosInstance.post(`${prefix}/api/sdk/upload_after`, form, {
      headers: {
        Cookies: `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}`,
      },
      onUploadProgress: ({ event }) => {
        const percent = Math.round((event.loaded * 100) / event.total);
        onProgress?.(percent);
      },
    })
      .then(({ data }) => {
        const downloadUrl = get(data, [file.name]);
        const uniqueId = get(data, ['unique_id']);
        const duration = Date.now() - startTime;
        if (uploadType === UploadFileType.reviewAttachment) {
          //上报文件和大小
          // c1: projectCode,
          // c2: roleInfo.originRole,
          // c3: requirementType,
          // c4: stage,

          sendEvent(CustomEvent.UploadAttachment, {
            et: 'OTHER',
            c5: file.type,
            c6: file.size,
            c7: duration,
            ...trackerObj,
          });
        }
        onSuccess?.(downloadUrl, uniqueId);
        showMessage && message.success(`${file.name}上传成功`);
        return downloadUrl;
      })
      .catch(() => {
        onError?.();
        message.error(`上传${file.name}失败`);
      });
  },
  fosLogin(rbacToken: string, user: string) {
    if (!fosHost) return;
    return FosAxiosInstance.post(
      `${prefix}/login`,
      {
        token: rbacToken,
        user: user,
      },
      {
        withCredentials: true,
      },
    );
  },
  fosLogout() {
    if (!fosHost) return Promise.resolve();
    return FosAxiosInstance.get(`${prefix}/logout`, { withCredentials: true });
  },
};

export default upload;
